import { Configuration } from "Configuration";
import { IDatabaseImageItem, IDataRequestOption, IDataRow, IMultipleControlRequestParameter } from "Entities";
import { BaseService } from "./BaseService";
import { CommandService } from "./CommandService";

export class DatabaseImageService extends BaseService {
    private controllerName: string = "image";

    /**
     * Get data for all databaseimages for a row.
     * @param gridId Id of the grid.
     * @param options List of request options.
     * @param dataRow Current datarow in grid / form.
     */
    public getAll(gridId: number, options: IDataRequestOption[], dataRow: IDataRow): Promise<{ [controlID: number]: IDatabaseImageItem }> {
        let param = <IMultipleControlRequestParameter>$.extend(CommandService.getRequestParameters(), { DataRow: dataRow }, { DataRequestOptions: options });
        return this.post(`${Configuration.baseUrl}${this.controllerName}/${gridId}`, param);
    }
}